import React from 'react';
import { forwardRef } from 'react';
import { LoadingSpinner } from '../LoadingSpinner';
export const Button = forwardRef(({ isLoading = false, spinnerClassName, disabled, children, ...rest }, ref) => {
    return (React.createElement("button", { disabled: isLoading || disabled, ref: ref, ...rest }, isLoading ? React.createElement(LoadingSpinner, { className: spinnerClassName }) : children));
});
